<template>
  <aRow :gutter="20">
    <aCol :span="12">
      <aFormItem class="form-item">
        <label class="filled" for>Valor total do pagamento</label>
        <aInput
          class="travel-input"
          placeholder="Valor total do pagamento"
          v-currency
          @keyup="updateCustomPaymentValue"
          v-decorator="[
            `payment_methods_custom_payment_total_value_${customPaymentId}${keySuffix}`,
            {
              rules: [
                {
                  required: true,
                  message: 'Preencha todos números.',
                },
                {
                  validator: verifyValue,
                },
              ],
            },
          ]"
        >
          <aIcon slot="prefix" type="field-svg" />
        </aInput>
      </aFormItem>
    </aCol>

    <aCol :span="12">
      <aFormItem class="form-item">
        <label class="filled" for>Nome da forma de Pagamento</label>
        <aInput
          class="travel-input"
          placeholder="Nome da forma de Pagamento"
          v-decorator="[
            `payment_methods_custom_payment_name_${customPaymentId}${keySuffix}`,
            {
              rules: [
                {
                  required: true,
                  message: 'Preencha o nome da forma de pagamento.',
                },
              ],
            },
          ]"
        >
          <aIcon slot="prefix" type="field-svg" />
        </aInput>
      </aFormItem>
    </aCol>

    <aCol :span="24">
      <aFormItem class="form-item textarea">
        <label class="filled" for>Observações (opcional)</label>

        <aInput
          class="travel-textarea"
          placeholder="Observações (opcional)"
          type="textarea"
          v-decorator="[
            `payment_methods_custom_payment_observation_${customPaymentId}${keySuffix}`,
          ]"
        >
        </aInput>
      </aFormItem>
    </aCol>
  </aRow>
</template>

<script>
import { parse } from "vue-currency-input";

export default {
  name: "CustomPaymentCollapse",
  props: {
    form: Object,
    customPaymentId: Number,
    tempContract: Object,
    keyPrefix: {
      type: String,
      default: "",
    },
    keySuffix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      banksList: [],
    };
  },
  mounted() {
    this.form.setFieldsValue({
      [`payment_methods_custom_payment_total_value_${this.customPaymentId}${this.keySuffix}`]:
        this.tempContract[
          `payment_methods_custom_payment_total_value_${this.customPaymentId}${this.keySuffix}`
        ],
      [`payment_methods_custom_payment_name_${this.customPaymentId}${this.keySuffix}`]:
        this.tempContract[
          `payment_methods_custom_payment_name_${this.customPaymentId}${this.keySuffix}`
        ],
      [`payment_methods_custom_payment_observation_${this.customPaymentId}${this.keySuffix}`]:
        this.tempContract[
          `payment_methods_custom_payment_observation_${this.customPaymentId}${this.keySuffix}`
        ],
    });

    this.$emit("updateCustomPaymentValue");
  },
  methods: {
    updateCustomPaymentValue() {
      this.$emit("updateCustomPaymentValue");
    },
    async verifyValue(rule, value, callback) {
      rule;
      let theValue = parse(value),
        totalValue = parseFloat(this.reservation_total_price);
      if (isNaN(theValue) || theValue == undefined) {
        theValue = 0;
      } else {
        if (parse(value) > totalValue) {
          callback(
            `O valor preenchido ultrapassa o total da reserva (R$ ${this.reservation_total_price}).`
          );
        } else {
          callback();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-item.textarea {
  position: relative;
  .filled {
    top: -46px;
    opacity: 1 !important;
  }
}
label {
  position: absolute;
  z-index: 4;
  font-size: 10px;
  font-weight: 500;
  color: #ccc;
  transition: 0.3s;
  opacity: 0;
  top: 13px;
  left: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  &.filled {
    top: -16px;
    opacity: 1 !important;
  }
}
</style>
